import { useContext } from 'react';

import { Maybe } from '@/types/Maybe';

export function createStoreHook<T>(store: React.Context<Maybe<T>>, storeName: string) {
  return function useStore(): T {
    const context = useContext(store);

    if (!context) {
      throw new Error(`use${storeName} must be used within a ${storeName}Provider`);
    }

    return context;
  };
}
